import React, { ReactElement } from 'react';

import { RadioProps } from './types';
import { Mark, Input, Wrapper } from './style';

const Radio = ({ color = 'primary_400', ...props }: RadioProps): ReactElement => (
  <Wrapper color={color}>
    <Input {...props} type="radio" />
    <Mark />
  </Wrapper>
);

export default Radio;
